import React, {useEffect} from 'react';
import { Card, Typography, useTheme } from '@mui/material';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from 'recharts';
import { useDispatch, useSelector } from 'react-redux';
import { getAvgEarningAndFollowUpRateRequest } from './../../store/appActions';

export default function AverageEarningChart() {
  const theme = useTheme();
 const dispatch = useDispatch();
  const data = useSelector((state) => state.app.avgEarningAndFollowUpRate || []);

    // console.log('data :',data)

  useEffect(() => {
    dispatch(getAvgEarningAndFollowUpRateRequest());
  }, [dispatch]);
  return (
    <Card
      sx={{
        p: 2,
        borderRadius: 2,
        boxShadow: theme.shadows[1],
        bgcolor: theme.palette.background.default,
      }}
    >
      <Typography
        variant="subtitle1"
        gutterBottom
        fontWeight="bold"
        color={theme.palette.text.primary}
      >
        Avg. Earning & Follow-Up Conversion / Month
      </Typography>

      <ResponsiveContainer width="100%" height={260}>
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" stroke={theme.palette.divider} />
          <XAxis
            dataKey="name"
            stroke={theme.palette.text.secondary}
            style={{ fontSize: 12 }}
          />
          <YAxis
            yAxisId="left"
            stroke={theme.palette.text.secondary}
            style={{ fontSize: 12 }}
            tickFormatter={(val) => `₹${val}`}
          />
          <YAxis
            yAxisId="right"
            orientation="right"
            stroke={theme.palette.text.secondary}
            style={{ fontSize: 12 }}
            tickFormatter={(val) => `${val}%`}
          />
          <Tooltip
            formatter={(value, name) =>
              name === 'Avg Earning' ? `₹${value}` : `${value}%`
            }
            contentStyle={{
              backgroundColor: theme.palette.background.paper,
              border: `1px solid ${theme.palette.divider}`,
              borderRadius: 4,
              fontSize: 13,
            }}
          />
          <Legend wrapperStyle={{ fontSize: 12, fontFamily: theme.typography.fontFamily }} />
          <Line
            yAxisId="left"
            type="monotone"
            dataKey="avgEarning"
            stroke={theme.palette.primary.main}
            strokeWidth={2}
            dot={{ r: 4, fill: theme.palette.primary.main }}
            activeDot={{ r: 6 }}
            name="Avg Earning"
          />
          <Line
            yAxisId="right"
            type="monotone"
            dataKey="followUpRate"
            stroke={theme.palette.secondary.main}
            strokeWidth={2}
            dot={{ r: 4, fill: theme.palette.secondary.main }}
            activeDot={{ r: 6 }}
            name="Follow-Up Rate"
          />
        </LineChart>
      </ResponsiveContainer>
    </Card>
  );
}
